import React from 'react'
import BrandPrinterSetup from '../BrandPrinterSetup'

const CaSearch = () => {
  return (
    <>
       <BrandPrinterSetup 
              brand="CANON" 
              image="https://support-printers.netlify.app/img/logo_01.png" 
            />

    </>
  )
}

export default CaSearch
